import lodash from "lodash";
import moment from "moment";
import { pipes } from "@next-core/pipes";
export function supply(attemptToVisitGlobals, providedGlobalVariables, mock) {
  const globalVariables = {};
  // Allow limited browser builtin values.
  for (const variableName of attemptToVisitGlobals) {
    if (!Object.prototype.hasOwnProperty.call(globalVariables, variableName)) {
      if (variableName === "undefined") {
        globalVariables[variableName] = undefined;
      } else if (providedGlobalVariables && Object.prototype.hasOwnProperty.call(providedGlobalVariables, variableName)) {
        globalVariables[variableName] = providedGlobalVariables[variableName];
      } else {
        const variable = supplyIndividual(variableName, mock);
        if (variable !== undefined) {
          globalVariables[variableName] = variable;
        }
      }
    }
  }
  return globalVariables;
}
const shouldOmitInLodash = new Set([
// Omit all mutable methods from lodash.
// But allow sequence methods like `_.chain`.
"fill", "pull", "pullAll", "pullAllBy", "pullAllWith", "pullAt", "remove", "reverse", "assign", "assignIn", "assignInWith", "assignWith", "defaults", "defaultsDeep", "merge", "mergeWith", "set", "setWith", "unset", "update", "updateWith",
/**
 * Ignore `Function` methods from lodash, too.
 * There are chances to invoke `Object.assign`, etc.
 *
 * E.g.:
 *
 * ```
 * _.wrap(_.method('constructor.assign',{b:2},{b:3}),(func,...a) => func(...a))({})
 * ```
 */
"after", "ary", "before", "bind", "bindKey", "curry", "curryRight", "debounce", "defer", "delay", "flip", "memoize", "negate", "once", "overArgs", "partial", "partialRight", "rearg", "rest", "spread", "throttle", "unary", "wrap"]);

// Omit all mutable methods from moment.
const shouldOmitInMoment = new Set(["lang", "langData", "locale", "localeData", "defineLocale", "updateLocale", "updateOffset"]);
const allowedGlobalObjects = new Set(["Array", "Boolean", "Date", "Infinity", "JSON", "Math", "NaN", "Number", "String", "RegExp", "decodeURI", "decodeURIComponent", "encodeURI", "encodeURIComponent", "isFinite", "isNaN", "parseFloat", "parseInt", "Map", "Set", "URL", "URLSearchParams", "WeakMap", "WeakSet", "atob", "btoa"]);
function supplyIndividual(variableName, mock) {
  switch (variableName) {
    case "Object":
      // Do not allow mutable methods like `Object.assign`.
      return delegateMethods(Object, ["entries", "fromEntries", "keys", "values"]);
    case "_":
      return Object.fromEntries(Object.entries(lodash).filter(entry => !shouldOmitInLodash.has(entry[0])).concat(mock ? [["uniqueId", prefix => `${prefix !== null && prefix !== void 0 ? prefix : ""}42`]] : []));
    case "moment":
      return Object.assign(function () {
        return moment(...arguments);
      }, Object.fromEntries(Object.entries(moment).filter(entry => !shouldOmitInMoment.has(entry[0]))));
    case "PIPES":
      return pipes;
    case "TAG_URL":
      return tagUrlFactory(true);
    case "SAFE_TAG_URL":
      return tagUrlFactory();
    default:
      if (allowedGlobalObjects.has(variableName)) {
        return window[variableName];
      }
  }
}
function delegateMethods(target, methods) {
  return Object.fromEntries(methods.map(method => [method, function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return target[method].apply(target, args);
  }]));
}
/**
 * Pass `ignoreSlashes` as `true` to encode all tagged expressions
 * as URL components, except for `/` which maybe used in `APP.homepage`.
 *
 * Otherwise encode all tagged expressions as URL components.
 * This will encode `/` as `%2F`. So do not use it directly
 * with `APP.homepage` as in template expressions.
 *
 * @example
 *
 * ```js
 * TAG_URL`${APP.homepage}/list?q=${q}&redirect=${redirect}`
 * ```
 *
 * ```js
 * SAFE_TAG_URL`file/${path}?q=${q}`
 * // `path` will be fully transformed by `encodeURIComponent`.
 * ```
 *
 * ```js
 * // Wrap `APP.homepage` outside of `SAFE_TAG_URL`.
 * `${APP.homepage}/${SAFE_TAG_URL`file/${path}?q=${q}`}`
 * ```
 */
function tagUrlFactory(ignoreSlashes) {
  return function (strings) {
    for (var _len2 = arguments.length, partials = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      partials[_key2 - 1] = arguments[_key2];
    }
    const result = [];
    strings.forEach((str, index) => {
      result.push(str);
      if (index < partials.length) {
        result.push(ignoreSlashes ? String(partials[index]).replace(/[^/]+/g, p => encodeURIComponent(p)) : encodeURIComponent(String(partials[index])));
      }
    });
    return result.join("");
  };
}
//# sourceMappingURL=index.js.map